import { z } from 'zod';

/**
 * Checks if a given value is a valid locale according to LocaleSchema.
 *
 * @param unknown The value to check using the Zod schema.
 * @returns True if the value is a valid locale string, false otherwise.
 */
export function isValidLocale(localeString: unknown): localeString is Locale {
	const result = LocaleSchema.safeParse(localeString);

	return result.success;
}

export const LocaleSchema = z.enum([
	'en-GB',
	'es-ES',
	'fr-FR',
	'ar-SA',
	'id-ID',
	'it-IT',
	'pt-BR',
	'pt-PT',
	'pl-PL',
	'de-DE',
	'ru-RU',
	'ko-KR',
	'he',
	'ja-JP',
	'zh-CN',
	'en-US',
	'tr-TR'
]);

export type Locale = z.infer<typeof LocaleSchema>;
